module.exports = __webpack_public_path__ + "img/Dompetkilat-Image@2x.ab915b9d.png";